/* WristPop Strap Finder — two-axis finder on the 8 Royal Pop PDPs.
 * Strap axis: shared StrapFinderEngine loadWatches() carousel (same look as the normal finder).
 * Case axis: ‹ › control; changes the fixed centre case+head AND recolours the clasp on EVERY strap.
 *
 * LAYER MODEL (all real transparent PNGs, one shared 1180x1280 canvas, artist-registered —
 * "just stack them"):
 *   per strap cell:   strap (back)  ->  clasp (case-coloured, covers the strap's case-zone band)
 *   fixed centre only:                                          case frame  ->  watch head (front)
 * The clasp colour follows the SELECTED CASE colour (not the strap) — clasp always matches case,
 * per the bundle structure. Side straps show the clasp so they read as complete straps; the
 * centred watch's case+head cover its own clasp.
 *
 * Data (Liquid emits per colour): strapFull, clasp, caseFrame (crown-correct), + head per product.
 * A colour with no strapFull is dropped from the strap axis; a missing caseFrame shows head-only
 * for that case colour (e.g. the one Light-Blue crown-12 gap). No placeholder-crop path anymore —
 * the full real asset set is uploaded, so layers are real or simply absent.
 * ES5, dependency-free until boot; engine deps polled like the reverse finder. */
(function () {
  'use strict';

  function ownFirst(own, all) {
    var out = [], i;
    own = own || []; all = all || [];
    for (i = 0; i < own.length; i++) if (all.indexOf(own[i]) >= 0 && out.indexOf(own[i]) < 0) out.push(own[i]);
    for (i = 0; i < all.length; i++) if (out.indexOf(all[i]) < 0) out.push(all[i]);
    return out;
  }
  function slug(s) { return s.toLowerCase().replace(/\s+/g, '-'); }

  function boot(root) {
    if (root.__wpfBooted) return;
    root.__wpfBooted = true;

    var cfgEl = root.querySelector('#wpf-config');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (cfg.colours) delete cfg.colours.__end;
    var C = cfg.colours || {};

    var container = root.querySelector('.wpf-reverse');
    var nameEl = root.querySelector('[data-wpf-name]');
    var counterEl = root.querySelector('[data-wpf-counter]');
    var caseNameEl = root.querySelector('[data-wpf-case-name]');
    var ovCase = root.querySelector('.wpf-ov-case');
    var ovHead = root.querySelector('.wpf-ov-head');
    var ctaEl = root.querySelector('[data-wpf-cta]');
    var ctaSummary = root.querySelector('[data-wpf-cta-summary]');
    var ctaPrice = root.querySelector('[data-wpf-cta-price]');
    var ctaCompare = root.querySelector('[data-wpf-cta-compare]');
    var ctaBtn = root.querySelector('[data-wpf-cta-btn]');

    function strapUrl(c) { return C[c] && C[c].strapFull; }
    function claspUrl(c) { return C[c] && C[c].clasp; }
    function caseUrl(c) { return C[c] && C[c].caseFrame; }

    // strap axis: own colours first, only those with a real strap asset
    var strapAxis = ownFirst(cfg.product.ownStrapColours, cfg.strapColours).filter(strapUrl);
    // case axis: own colours first, every colour manufactured in this listing's crown layout
    var caseAxis = ownFirst(cfg.product.ownCaseColours, cfg.caseColours).filter(function (c) { return !!C[c]; });
    if (!strapAxis.length || !caseAxis.length) return;

    var headUrl = cfg.head && cfg.head.url;
    var caseIdx = 0;
    var selectedStrap = strapAxis[0];

    // ---- "Add this look" — adds ONE model set variant, qty 1. wpf-two-kit-rewire.
    // That variant is itself the native bundle of 1 x Case Kit + 1 x Strap Kit, so the
    // single line carries the $145 set price. Never add the two kits as separate lines:
    // kits bought separately are not flagged for 3PL assembly and would ship unassembled.
    // Uses the theme's native drawer flow: _dlcUserAddToCart + a CartJS request ->
    // cart.requestComplete handler refreshes AND opens the drawer (see jsc-reset-scripts.js).
    var look = cfg.look || {};
    var CTA_LABEL = 'Add this look to cart';
    function lookSet() {
      return (cfg.setVariants || {})[caseAxis[caseIdx] + '|' + selectedStrap] || null;
    }
    function updateCTA() {
      if (!ctaEl || !look.enabled) return;
      var set = lookSet();
      var caseColour = caseAxis[caseIdx];
      if (ctaSummary) ctaSummary.textContent = caseColour + ' case & clasp · ' + selectedStrap + ' strap';
      if (ctaPrice) ctaPrice.textContent = look.price || '';
      if (ctaCompare) ctaCompare.textContent = (look.compare && look.compare !== look.price) ? look.compare : '';
      // A set variant exists for every combination, but it is only purchasable once
      // inventory opens — keep the button visible and explain why it is inert.
      ctaBtn.disabled = !set || !set.a;
      ctaBtn.textContent = (set && !set.a) ? 'Not yet available' : CTA_LABEL;
      ctaEl.hidden = false;
    }
    function addLook() {
      var set = lookSet();
      if (!set || !set.a || ctaBtn.disabled) return;
      var lookTag = (look.model ? look.model + ' · ' : '') + caseAxis[caseIdx] + ' case · ' + selectedStrap + ' strap';
      // Carry the same "Pre-order" line-item property the PDP writes, from the same
      // metaobject, so a finder purchase records the shipping commitment on the order too.
      // `set.p` mirrors the PDP's condition (continue + no stock), so once real stock lands
      // this stops attaching itself — no manual step and never a stale promise.
      var lookProps = { _wpf_look: lookTag };
      // wpf-byo-attribution (19 Aug): same as the landing finder — off-model combinations
      // resolve to Build Your Own variants whose SKU does not name the watch model. The
      // hidden _model property survives onto lineItemGroup.customAttributes for the report.
      if (look.model) lookProps._model = look.model;
      var poText = set.t || cfg.preorderText;   // per-variant date (Light Blue/White) wins
      if (set.p && poText) lookProps['Pre-order'] = poText;
      ctaBtn.disabled = true;
      ctaBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: set.i, quantity: 1, properties: lookProps }
        ] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || r.status); });
        return r.json();
      }).then(function () {
        ctaBtn.textContent = '✓ Added to cart';
        // native drawer refresh+open: flag as a genuine user add, then complete a CartJS request
        if (window.CartJS && window.CartJS.getCart) {
          window._dlcUserAddToCart = true;
          window.CartJS.getCart();
        } else {
          window.location.href = '/cart';
        }
        setTimeout(function () { ctaBtn.textContent = CTA_LABEL; ctaBtn.disabled = false; }, 2500);
      }).catch(function (e) {
        ctaBtn.textContent = 'Couldn’t add — try again';
        setTimeout(function () { ctaBtn.textContent = CTA_LABEL; ctaBtn.disabled = false; }, 2500);
      });
    }
    if (ctaBtn) ctaBtn.addEventListener('click', addLook);

    // ---- fixed centre overlay (case + head): watch stays PINNED, straps travel underneath ----
    function paintOverlay() {
      var cc = caseAxis[caseIdx];
      var cu = caseUrl(cc);
      if (ovCase) {
        if (cu) { ovCase.src = cu; ovCase.style.display = ''; ovCase.classList.add('is-ready'); }
        else { ovCase.style.display = 'none'; } // rare crown gap -> head-only
      }
      if (ovHead) {
        if (headUrl) { ovHead.src = headUrl; ovHead.style.display = ''; ovHead.classList.add('is-ready'); }
        else { ovHead.style.display = 'none'; }
      }
      if (caseNameEl) caseNameEl.textContent = cc + '  ·  ' + (caseIdx + 1) + '/' + caseAxis.length;
    }

    // ---- per-cell clasp: EVERY strap gets a clasp, colour = selected case ----
    function updateClasps() {
      var cu = claspUrl(caseAxis[caseIdx]);
      var imgs = container.querySelectorAll('img.wpf-clasp');
      for (var i = 0; i < imgs.length; i++) {
        if (cu) { imgs[i].src = cu; imgs[i].style.display = ''; }
        else { imgs[i].style.display = 'none'; }
      }
    }
    function injectClasps() {
      var cells = container.querySelectorAll('.columns');
      for (var i = 0; i < cells.length; i++) {
        if (!cells[i].querySelector('img.wpf-clasp')) {
          var img = document.createElement('img');
          img.className = 'wpf-clasp'; img.alt = '';
          cells[i].appendChild(img);
        }
      }
      updateClasps();
    }

    function cycleCase(delta) {
      caseIdx = (caseIdx + delta + caseAxis.length) % caseAxis.length;
      paintOverlay(); updateClasps(); updateCTA();
    }
    root.querySelector('[data-wpf-case-prev]').addEventListener('click', function () { cycleCase(-1); });
    root.querySelector('[data-wpf-case-next]').addEventListener('click', function () { cycleCase(1); });

    // ---- start the shared engine once its deps are up (reverse-finder boot pattern) ----
    var tries = 0;
    (function waitDeps() {
      var ok = window.StrapFinderEngine && window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity && window.imagesLoaded;
      if (!ok) {
        if (++tries > 100) { if (nameEl) nameEl.textContent = 'Finder unavailable (engine not loaded)'; return; }
        return setTimeout(waitDeps, 100);
      }
      var engine = window.StrapFinderEngine({
        $: window.jQuery,
        container: container,
        overlay: null,
        // URLs arrive fully sized from Liquid image_url. These MUST be truthy no-ops: the
        // engine does `config.cropDesktop || DEFAULT_CROP_DESKTOP`, so '' would fall back to
        // the finder's region crops and mangle our full-canvas PNGs.
        cropMobile: 'sfnoop=1', cropDesktop: 'sfnoop=1', faceCrop: 'sfnoop=1',
        onSelect: function (sel) {
          if (nameEl) nameEl.textContent = (sel && sel.title) || '';
          if (sel && sel.handle) {
            for (var s = 0; s < strapAxis.length; s++) {
              if (slug(strapAxis[s]) === sel.handle) { selectedStrap = strapAxis[s]; break; }
            }
            updateCTA();
          }
        },
        onCounter: function (cur, total) { if (counterEl) counterEl.textContent = cur + ' / ' + total; }
      });
      var items = [];
      for (var i = 0; i < strapAxis.length; i++) {
        var su = strapUrl(strapAxis[i]);
        items.push({
          head: headUrl || su,     // per-cell watch is display:none; value unused but must be non-empty
          top: su,                 // the full strap (one continuous PNG)
          bottom: su,              // same URL, hidden via CSS (cached; keeps engine markup valid)
          topMargin: 0, bottomMargin: 0,
          title: strapAxis[i] + ' strap',
          handle: slug(strapAxis[i]),
          alt: cfg.product.title + ' with ' + strapAxis[i] + ' strap'
        });
      }
      engine.loadWatches(items);
      paintOverlay();
      updateCTA();
      // engine builds + clone-fills cells synchronously; add the clasp layer once the DOM
      // settles, then again after imagesLoaded in case Flickity re-parented late
      setTimeout(injectClasps, 50);
      setTimeout(injectClasps, 1500);
    })();
  }

  try { window.__wpfFinder = { loaded: true, inits: 0, booted: 0 }; } catch (e) {}

  function init() {
    var roots = document.querySelectorAll('[data-wpf-root]');
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        // init() fires from several triggers below, so running it again must be free.
        if (root.getAttribute('data-wpf-init') === '1') return;
        root.setAttribute('data-wpf-init', '1');

        var done = false;
        function go() {
          if (done) return; done = true;
          try { window.__wpfFinder.booted++; } catch (e) {}
          boot(root);
        }
        function near() {
          var b = root.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          return b.top < vh + 500 && b.bottom > -500;
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) { io.disconnect(); go(); break; }
            }
          }, { rootMargin: '400px 0px' });
          io.observe(root);
        }

        // Visibility is POLLED as well as observed — this is the fix, not belt-and-braces.
        // Measured 2026-08-18 with every dependency loaded and the section at top:280 in a
        // 900px viewport: the observer had still never fired and the finder read "Loading..."
        // indefinitely. wristpop-page-finder.js hit the same thing and was hardened this way:
        // an IntersectionObserver created while the viewport had zero height never fires
        // again, and the theme's nested flex wrappers swallow scroll events. A 250ms rect
        // check cannot get into either state, costs nothing, and stops as soon as it boots.
        var ticks = 0;
        (function poll() {
          if (done) return;
          if (near()) return go();
          if (++ticks > 240) return go();   // ~60s: boot regardless rather than never
          setTimeout(poll, 250);
        })();
      })(roots[i]);
    }
  }

  function initAll() {
    try { window.__wpfFinder.inits++; } catch (e) {}
    init();
  }

  // Fire on every reasonable trigger. init() guards each root with data-wpf-init, so running
  // repeatedly is free — and no single ordering quirk (deferred execution, a theme that
  // re-inserts sections, a zero-height viewport at parse time) can leave the finder dead.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', initAll);
  setTimeout(initAll, 1200);
  setTimeout(initAll, 4000);
})();
